import React from 'react'
import { Switch, Route, useRouteMatch, useHistory, useLocation } from 'react-router-dom'
import { ProfileProposalForm } from './ProfileProposalForm';
import ProposalSessionContext from '../../context/ProposalSessionContext';
import { CustomizePolicy } from '../Insurance/CustomizePolicy';
import BuyingInsuranceContext from '../../context/BuyingInsuranceContext';
import InsurancePurchaseContext from '../../context/InsuracePurchaseContext';
import NewFillButton from '../Core/NewFillButton';
import { Container } from '@material-ui/core';
import { EventEmitterService, EventKey } from '../../services/EventEmitterService';

export const ProposalRoutes = () => {
    const { path, url } = useRouteMatch();
    const history = useHistory()
    const location = useLocation()

    React.useEffect(() => {
        let id = EventEmitterService.subscribe(EventKey.FLOW_CUSTOMIZE_FINISH, () => {
            history.push({pathname: `${path}/profile`, search: location.search})
        })

        let id2 = EventEmitterService.subscribe(EventKey.FLOW_GO_BACK, () => {
            history.goBack()
        })

        return function cleanup () {
            EventEmitterService.unsubscribe(EventKey.FLOW_CUSTOMIZE_FINISH, id)
            EventEmitterService.unsubscribe(EventKey.FLOW_GO_BACK, id2)
        }
    }, [])

    return ( <ProposalSessionContext>
        <Switch>
            <Route path={`${path}/profile`}>
                <ProfileProposalForm />
            </Route>

            <Route path={`${path}/insurance/(monthly|annual)`}>
                <BuyingInsuranceContext>
                    <InsurancePurchaseContext>
                        <CustomizePolicy />
                    </InsurancePurchaseContext>
                </BuyingInsuranceContext>
            </Route>
        </Switch>
    </ProposalSessionContext>)
}